import React from "react"
import { Badge } from "@love-irish/ui-components"
import { twMerge } from "tailwind-merge"

export interface KindBadgeProps {
  /** The headword's base kind: word | phrase | proverb. */
  kind?: "word" | "phrase" | "proverb" | string | null
  className?: string
}

const colors: Record<string, string> = {
  word: "text-water-500",
  phrase: "text-earth-500",
  proverb: "text-fire-500",
}

/**
 * Outline badge for a headword's base kind (WORD / PHRASE / …), shown next to the base word. Uppercased
 * for a quiet, label-style treatment. Renders nothing when the kind is absent.
 */
export const KindBadge: React.FC<KindBadgeProps> = ({ kind, className }) => {
  if (!kind) return null

  return (
    <Badge
      variant="outline"
      className={twMerge(
        "uppercase font-bold tracking-wide text-muted-foreground",
        colors[kind],
        className
      )}
    >
      {kind}
    </Badge>
  )
}

export default KindBadge
